import { render } from "./AchOrigination.vue?vue&type=template&id=f82dc91a"
import script from "./AchOrigination.vue?vue&type=script&lang=js"
export * from "./AchOrigination.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__